module.exports = __webpack_public_path__ + "img/ex-timeline_xl.5108166a.png";